import React, { useState } from "react";
import { useForm } from "react-hook-form";

function FileManagerModal({
  title,
  action,
  defaultValue,
  onSubmit,
  onClose,
  folders,
  goToFolder,
  goBack,
  currentPath,
  loading,
}) {
  const { register, handleSubmit, setValue } = useForm({
    defaultValues: {
      folderName: action === "create" ? "" : defaultValue,
      newName: defaultValue,
      uploadLink: "", // Add a default value for uploadLink
    },
  });

  const [destinationPath, setDestinationPath] = useState(currentPath);

  const handleFileChange = (e) => {
    setValue("files", e.target.files);
  };

  const handleFolderSelect = (folderName) => {
    goToFolder(folderName);
    setDestinationPath((prevPath) =>
      prevPath === "\\" ? `\\${folderName}` : `${prevPath}\\${folderName}`
    );
  };

  const handleGoBack = () => {
    const segments = destinationPath.split("\\").filter(Boolean);
    segments.pop();
    const newPath = segments.length ? `\\${segments.join("\\")}` : "\\";
    setDestinationPath(newPath);
    goBack();
  };

  const submitData = (data) => {
    if (action === "upload") {
      data.files = data.files || [];
    } else if (action === "copy" || action === "move") {
      data.destinationPath = destinationPath;
    } else if (action === "uploadLink") {
      // Return the upload link
      data.link = data.uploadLink; // Capture the link value
    }
    onSubmit(data);
  };

  const getFieldName = () => (action === "create" ? "folderName" : "newName");

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={handleSubmit(submitData)}>
              <div className="modal-header">
                <h5 className="mb-0">{title}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                ></button>
              </div>
              <div className="modal-body">
                {loading && (
                  <div className="file-manager-loader-overlay">
                    <div className="fa fa-spinner fs-7"></div>
                  </div>
                )}
                {action === "upload" ? (
                  <div className="mb-3">
                    <label className="form-label">Select Files</label>
                    <input
                      type="file"
                      className="form-control"
                      multiple
                      onChange={handleFileChange}
                    />
                  </div>
                ) : action === "copy" || action === "move" ? (
                  <>
                    <button
                      className="btn btn-outline-primary px-2 py-1 mb-2"
                      onClick={handleGoBack}
                      type="button"
                    >
                      Go Back
                    </button>
                    <strong className="fs-9 d-block mb-1">
                      Current Location: {destinationPath}
                    </strong>
                    <ul className="list-group">
                      {folders.map(
                        (folder) =>
                          folder.type === "Folder" && (
                            <li
                              key={folder.name}
                              className="list-group-item list-group-item-action fs-9"
                              onClick={() => handleFolderSelect(folder.name)}
                              style={{ cursor: "pointer" }}
                            >
                              {folder.name}
                            </li>
                          )
                      )}
                    </ul>
                  </>
                ) : action === "uploadLink" ? (
                  <div className="mb-3">
                    <label className="form-label">Link</label>
                    <input
                      {...register("uploadLink", {
                        required: "This field is required.",
                      })}
                      type="text"
                      className="form-control"
                      placeholder="Enter Link"
                    />
                  </div>
                ) : (
                  <div className="mb-3">
                    <label className="form-label">
                      {action === "create" ? "Folder Name" : "New Name"}
                    </label>
                    <input
                      {...register(getFieldName(), {
                        required: "This field is required.",
                      })}
                      type="text"
                      className="form-control"
                      placeholder={
                        action === "create"
                          ? "Enter folder name"
                          : "Enter new name"
                      }
                    />
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-sm btn-primary">
                  {action === "copy"
                    ? "Copy"
                    : action === "move"
                    ? "Move"
                    : "Submit"}
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default FileManagerModal;
